import { useEffect } from 'react'
import { useMouseEvents } from '~/hooks/useMouseEvents'

/** Returns state that is true when a user's mouse button is down. */
export const useUserClickedExternalElements = (
  elements: (Element | null)[],
  scanChildren = true,
  onTrigger?: () => void,
) => {
  const mouseDownEvent = useMouseEvents()
  useEffect(() => {
    if (elements.length === 0) return
    if (!(mouseDownEvent?.target instanceof Element)) return

    if (
      elements.some(
        (element) =>
          element === (element && mouseDownEvent.target) ||
          (scanChildren && element!.contains(mouseDownEvent.target as Node)),
      )
    ) {
      return
    }

    onTrigger?.()
  }, [elements, mouseDownEvent])
}
